import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, MessageCircle, Clock } from 'lucide-react';
import { restaurantInfo } from '../mock';

const Footer = () => {
  const quickLinks = [
    { path: '/', label: 'Home' },
    { path: '/menu', label: 'Menu' },
    { path: '/about', label: 'About Us' },
    { path: '/gallery', label: 'Gallery' },
    { path: '/events', label: 'Events' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <footer className="bg-[#2C3E50] text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Column 1 - About */}
          <div>
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: "'Playfair Display', serif", color: '#F39C12' }}>
              The Grill
            </h3>
            <p className="text-gray-300 mb-4">
              Jabalpur's finest dining destination, serving authentic North Indian, Chinese, and Continental cuisine with passion and excellence.
            </p>
            <div className="flex items-center space-x-2 text-[#F39C12]">
              <span className="text-2xl font-bold">{restaurantInfo.rating}</span>
              <span className="text-sm">★ ({restaurantInfo.reviewCount}+ Reviews)</span>
            </div>
          </div>

          {/* Column 2 - Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-300 hover:text-[#F39C12] transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3 - Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-[#F39C12] flex-shrink-0 mt-1" />
                <span className="text-gray-300">{restaurantInfo.address}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-[#F39C12]" />
                <a href={`tel:${restaurantInfo.phone}`} className="text-gray-300 hover:text-[#F39C12]">
                  {restaurantInfo.phone}
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-[#F39C12]" />
                <a href={`mailto:${restaurantInfo.email}`} className="text-gray-300 hover:text-[#F39C12]">
                  {restaurantInfo.email}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Clock className="w-5 h-5 text-[#F39C12] flex-shrink-0 mt-1" />
                <div className="text-gray-300">
                  <div>Mon-Fri: {restaurantInfo.hours.weekdays}</div>
                  <div>Sat-Sun: {restaurantInfo.hours.weekends}</div>
                </div>
              </li>
            </ul>
          </div>

          {/* Column 4 - Connect */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Connect With Us</h4>
            <div className="flex space-x-4 mb-6">
              <a
                href={restaurantInfo.socialMedia.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#F39C12] transition-colors duration-200"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href={restaurantInfo.socialMedia.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#F39C12] transition-colors duration-200"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href={restaurantInfo.socialMedia.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#F39C12] transition-colors duration-200"
              >
                <MessageCircle className="w-5 h-5" />
              </a>
            </div>
            <div className="space-y-2">
              <Link to="/events" className="block text-gray-300 hover:text-[#F39C12] transition-colors">
                Private Events
              </Link>
              <Link to="/testimonials" className="block text-gray-300 hover:text-[#F39C12] transition-colors">
                Customer Reviews
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-8 pt-6 text-center">
          <p className="text-gray-400">
            © 2024 The Grill. All Rights Reserved. | Designed with ❤️ for food lovers
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
